// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1KPTo","title":"ClientInsurance_title__39tvv","itemText":"ClientInsurance_itemText__1u7HF"};